$("._show-search").click(function () {
    $(".header-search").addClass("_active")
    $(".header-search__field input").focus()
})

$(document).mouseup(function(e) {
    var div = $('.header-search');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if($(div).hasClass("_active")){
            $(div).removeClass("_active")
        }
    }
});

$(".menu__item").mouseover(function() {
    $(".menu__item").removeClass("_active")
    $(this).addClass("_active")
})

$(".menu__item").mouseout(function() {
    $(this).removeClass("_active")
})



$(".menu__item-show").click(function() {
    if(window.innerWidth<=992){
        $(this).parents(".menu__item").toggleClass("_active")
        $(this).siblings(".menu__item-hidden").slideToggle()
    }
})

$(".submenu__bg").click(function() {
    $(".menu__item").removeClass("_active")
    $(".page").removeClass("fixed-body")
})

$(".burger").click(function () {
    $(".header").addClass("_open")
    $("body").addClass("fixed-body")
})

$(".menu__bg").click(function () {
    $(".header").removeClass("_open")
    $("body").removeClass("fixed-body")
})
